<template>
    <div class="rankdetail">
      <!-- <div class="jjxq">
        <div>基金详情</div>
      </div> -->
      <div class="jjxq-con">
        <div>
          <div class="title jjxqtext"></div>
          <div>
            <div class="detailcontent">
              <div class="headpic">
                <img src="../assets/headpic.png" />
                <div class="name">{{productInfo.productName}}</div>
              </div>
              <div class="infodetail">
                <div class="otherinfo">
                  <div class="glr">管理人：{{productInfo.institutName}}</div><div class="times">
                    <div>开始时间：<span>{{productInfo.beginDate}}</span></div>
                    <div>结束时间：<span>{{productInfo.endDate}}</span></div>
                  </div>
                </div>
                <ul class="chartsname"><li :class="[{'active':activeTab=='ljdwjz'}]" @click="getData('ljdwjz')"><span v-if="activeTab!='ljdwjz'">累计净值</span><img v-if="activeTab=='ljdwjz'" src="../assets/ljdwjz.png" /></li><li :class="[{'active':activeTab=='dnljsyl'}]" @click="getData('dnljsyl')"><span v-if="activeTab!='dnljsyl'">累计收益率</span><img v-if="activeTab=='dnljsyl'" src="../assets/ljsyl.png" /></li><li :class="[{'active':activeTab=='nhsy'}]" @click="getData('nhsy')"><span v-if="activeTab!='nhsy'">年化收益</span><img v-if="activeTab=='nhsy'" src="../assets/nhsy.png" /></li><li :class="[{'active':activeTab=='sharp'}]" @click="getData('sharp')"><span v-if="activeTab!='sharp'">夏普比率</span><img v-if="activeTab=='sharp'" src="../assets/sharp.png" /></li><li :class="[{'active':activeTab=='zhzl'}]" @click="getData('zhzl')"><span v-if="activeTab!='zhzl'">账户总览</span><img v-if="activeTab=='zhzl'" src="../assets/zhzl.png" /></li></ul>
                <div id="charts"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import echarts from 'echarts'
    import {http} from '../fetch/api'
    export default {
      data() {
        return {
          productInfo:{},
          name: "累计净值",
          activeTab:"ljdwjz",
          seriesData:[]
        }
      },
      mounted() {
        this.getInfo()
      },
      methods:{
        getData(tab) {
          this.activeTab=tab
          switch (tab) {
            case 'ljdwjz': {
              this.name='累计净值'
              this.seriesData = this.productInfo.ljdwjzs
              this.showchart()
              break
            }
            case 'bjyk':
            {
              this.name='本届盈亏'
              this.seriesData = this.productInfo.ljykes
              this.showchart()
              break
            }
            case 'dnljsyl':
            {
              this.name='累计收益率'
              this.seriesData = this.productInfo.dnsyls
              this.showchart()
              break
            }
            case 'nhsy':
            {
              this.name='年化收益'
              this.seriesData = this.productInfo.nhsyls
              this.showchart()
              break
            }
            case 'sharp':
            {
              this.name='夏普比率'
              this.seriesData = this.productInfo.sharps
              this.showchart()
              break
            }
            case 'zhzl': {
              this.seriesData = this.productInfo.ljykes
              this.showallchart()
              break
            }
          }
        },
        showallchart() {
          var myChart = echarts.init(document.getElementById('charts'));
          myChart.clear()
          myChart.setOption({
            title: {
              text: ""
            },
            tooltip : {
              trigger: 'axis',
              axisPointer: {
                type: 'cross'
              },
              formatter(params) {
              let list = ''
              params.forEach((item,index) => {
                if(item.seriesName == '累计收益率' || item.seriesName == '年化收益') {
                  item.value = item.value ? Math.round(item.value*100*100)/100 + '%' : item.value
                } 
                list += item.marker + item.seriesName + ':' + item.value + '</br>'
              });
              return '<div>' + params[0].axisValue + '</br>' + list + '</div>'
            }
            },
            legend: {
              data:['累计净值','累计收益率','年化收益','夏普比率']
            },
            xAxis: {
              data: this.productInfo.recordDates
            },
            yAxis: {},
            series: [{
              name:'累计净值',
              type: 'line',
              data: this.productInfo.ljdwjzs
            // },{
            //   name:'本届盈亏',
            //   type: 'line',
            //   data: this.productInfo.ljykes
            },{
              name: '累计收益率',
              type: 'line',
              data: this.productInfo.dnsyls
            },{
              name:'年化收益',
              type: 'line',
              data: this.productInfo.nhsyls
            },{
              name:'夏普比率',
              type: 'line',
              data: this.productInfo.sharps
            }]
          });
        },
        showchart() {
          var myChart = echarts.init(document.getElementById('charts'));
          myChart.clear()
          myChart.setOption({
            title: {
              text: ""
            },
            tooltip : {
              trigger: 'axis',
              axisPointer: {
                type: 'cross'
              },
            formatter:function(params){  
              let ser = params[0]
              let value = ser.value ? (Math.round(ser.value * 100 * 100)/100 + '%') :ser.value
              if(ser.seriesName == '累计收益率' || ser.seriesName == '年化收益') {
                return '<div>' + ser.axisValue + '<br>' + ser.marker + ser.seriesName + ':' + value + '</div>'
              } else {
                return '<div>' + ser.axisValue + '<br>' + ser.marker + ser.seriesName + ':' + ser.value + '</div>'
              }
            }
            },
            legend: {
              data:[this.name]
            },
            xAxis: {
              data: this.productInfo.recordDates
            },
            yAxis: {},
            series: [{
              name: this.name,
              type: 'line',
              data: this.seriesData
            }]
          });
        },
        async getInfo() {
          console.log(this.$route.query)
          var data = await http.proDetailPrev(this.$route.query.productId,this.$route.query.series)
          this.productInfo=data.data
          this.seriesData = this.productInfo.ljdwjzs
          this.showchart()
        }
      }
    }
  </script>
  <style scoped>
  
    .jjxq {
      height: 60px;
      line-height: 60px;
      background: #f4f7f9;
    }
  
    .jjxq div {
      width: 1200px;
      margin: 0 auto;
      font-size: 16px;
    }
  
    .jjxq-con > div {
      padding: 50px 0;
      width: 1200px;
      margin: 0 auto;
    }
  
    .title {
      height: 67px;
      line-height: 67px;
      text-align: center;
      font-size: 30px;
      letter-spacing: 5px;
      margin: 0 auto 35px auto;
      background-repeat: no-repeat;
      background-size: 750px;
      background-position: center;
    }
  
    .title span {
      padding-left: 50px;
      display: inline-block;
      background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
      background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
      background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
      background-image: linear-gradient(73deg, #0c3b95, #cf5860);
      -webkit-background-clip: text;
      -o-background-clip: text;
      -ms-background-clip: text;
      -moz-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      -o-text-fill-color: transparent;
      -moz-text-fill-color: transparent;
      text-fill-color: transparent;
      font-weight: bold;
  
    }
    .jjxqtext {
      background-image: url("../assets/jjxq.png");
    }
    .detailcontent {
      padding-top: 0;
      height: 572px;
      background-size: contain;
      background-image: url("../assets/jjxqwk.png");
      background-repeat: no-repeat;
    }
    .headpic {
      padding-top: 50px;
      display: inline-block;
      width: 280px;
      text-align: center;
    }
    .headpic img {
      width: 140px;
    }
    .name {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      line-height: 22px;
      letter-spacing: 1.6px;
      color: #0d225c;
    }
    .infodetail {
      vertical-align: top;
      display: inline-block;
      width: 900px;
    }
    .otherinfo {
      margin-top: 50px;
    }
    .otherinfo >div {
      display: inline-block;
      width: 50%;
    }
    .glr {
      padding-left: 30px;
      box-sizing: border-box;
    }
    .times {
      text-align: right;
      padding-right: 30px;
      box-sizing: border-box;
    }
    .times>div {
     display: inline-block;
      margin-left: 20px;
    }
    .times span {
      color: #193aa9;
    }
    .chartsname {
      padding-left: 50px;
      width: 832px;
      margin: 0 auto;
      margin-top: 30px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      list-style: none;
      background: url("../assets/xzl.png") no-repeat center;
      background-size: contain;
    }
    .chartsname li {
      padding: 0 30px;
      width: 160px;
      box-sizing: border-box;
      display: inline-block;
      text-align: center;
    }
    .chartsname li img {
      vertical-align: middle;
      width: 100px;
    }
    .active {
      background: url("../assets/activeitem.png") no-repeat center top;
    }
    #charts {
      height: 400px;
      margin-top: 30px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/prevdetail.vue